import { render, staticRenderFns } from "./TreeNode.vue?vue&type=template&id=1545d2b9&scoped=true&"
import script from "./TreeNode.vue?vue&type=script&lang=ts&"
export * from "./TreeNode.vue?vue&type=script&lang=ts&"
import style0 from "./TreeNode.vue?vue&type=style&index=0&id=1545d2b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1545d2b9",
  null
  
)

export default component.exports